import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  TributacaoMensagemDto,
  TributacaoMensagemFiltrarDto,
  TributacaoMensagemFiltrarSchema,
} from "./TributacaoMensagem.Dto";
import { useEffect, useState } from "react";
import { TributacaoMensagemFiltrar } from "src/services/Fiscal.Service";
import { MapearErrosServidor } from "src/hook/Functions";
import { showToast } from "src/componentes";

const TributacaoMensagemCode = () => {
  const [data, setData] = useState<TributacaoMensagemDto[] | undefined>([]);
  const [allData, setAllData] = useState<TributacaoMensagemDto[]>([]);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm<TributacaoMensagemFiltrarDto>({
    resolver: yupResolver(TributacaoMensagemFiltrarSchema),
  });

  const carregarMensagens = async () => {
    setLoading(true);
    try {
      const response = await TributacaoMensagemFiltrar({});
      if (response.data.success) {
        const result = Array.isArray(response.data.data)
          ? response.data.data
          : response.data.data
          ? [response.data.data]
          : [];
        setData(result);
        setAllData(result);
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao buscar dados",
        title: "Erro",
        variant: "Danger",
      });
      setData(undefined);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    carregarMensagens();
    return () => {
      controller.abort();
    };
  }, []);

  const onSubmit = async (formData: TributacaoMensagemFiltrarDto, e?: any) => {
    setLoading(true);
    try {
      const termo = formData.mensagem?.trim().toLowerCase() || "";
      const isNumero = /^\d+$/.test(termo);

      const params: TributacaoMensagemFiltrarDto = {};
      if (isNumero) {
        params.id = Number(termo);
      }

      const response = await TributacaoMensagemFiltrar(params);
      if (response.data.success) {
        let result: TributacaoMensagemDto[] = Array.isArray(response.data.data)
          ? response.data.data
          : response.data.data
          ? [response.data.data]
          : [];

        if (termo && !isNumero) {
          result = result.filter((item) =>
            item.mensagem?.toLowerCase().includes(termo)
          );
        }

        setData(result);
        if (result.length === 0) {
          showToast({
            message: "Não encontrado",
            title: "Info",
            variant: "Info",
          });
        }
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      setData(undefined);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    register,
    handleSubmit,
    onSubmit,
    errors,
    recarregar: carregarMensagens,
  };
};

export default TributacaoMensagemCode;
